import {ref, Ref} from '@vue/composition-api';
export class EditorNodeInfoStoreControllerClass {
	private static _instance: EditorNodeInfoStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorNodeInfoStoreControllerClass());
	}

	private constructor() {}

	private _shaderExpanded!: Ref<boolean>;
	init() {
		this._shaderExpanded = ref(false);
	}
	shaderExpanded() {
		return this._shaderExpanded;
	}
}

export const EditorNodeInfoStoreController = EditorNodeInfoStoreControllerClass.instance();
